import * as React from 'react';
import Typography from '@mui/material/Typography';
import { DateTimePicker } from '@mui/x-date-pickers-pro';
import { format } from 'date-fns';
import { useTheme } from '@mui/material';

type Props = {
  onChange: (value: Date) => void;
  closeModal?: () => void;
};

export default function CustomTime({ onChange, closeModal }: Props) {
  const theme = useTheme();
  const [showCustomDate, setShowCustomDate] = React.useState(false);
  const [startDate, setStartDate] = React.useState<Date>();

  function clickHandle(datetime: Date) {
    onChange(datetime);
    closeModal?.();
  }

  return (
    <>
      {!showCustomDate && (
        <div
          role="presentation"
          className="time-item"
          onClick={() => {
            setShowCustomDate(true);
            setStartDate(undefined);
          }}
          style={{
            borderWidth: 1,
            borderColor: theme.palette.primary.main,
            borderRadius: 5,
            padding: 10,
            alignItems: 'center',
            backgroundColor: startDate ? theme.palette.primary.main : '#ffffff',
          }}>
          <Typography
            variant="h3"
            style={{
              color: startDate ? '#ffffff' : theme.palette.primary.main,
            }}>
            {startDate ? format(startDate, 'MM/dd/yyyy h:mma') : 'Custom date'}
          </Typography>
        </div>
      )}

      {showCustomDate && (
        <DateTimePicker
          onChange={(...args) => {
            const [value, context] = args;
            const isInvalid = !!context.validationError;
            if (isInvalid || !value) return;
            setStartDate(value);
            clickHandle(value);
          }}
        />
      )}
    </>
  );
}
